module.exports = __webpack_public_path__ + "img/32.1f5a95d6.jpg";